import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Box,
    Typography,
    Button,
    IconButton,
    Modal,
} from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
// import CloseIcon from "@mui/icons-material/Close";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import PrintIcon from "@mui/icons-material/Print";
import { NavLink } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { getGenericReviewRequestAysnc } from "features/actions/auth";
import toast from "react-hot-toast";
const BIButton = () => {
    const printRef = useRef();
    const [viewQrModalOpen, setViewQrModalOpen] = useState(false);
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 550,
        bgcolor: "background.paper",
        borderRadius: "12px",
        boxShadow: 24,
        p: { xs: 1, sm: 4 },
        textAlign: "center",
        py: 2,
    };

    const business_id = useSelector((state) => state.dashboard.commonId);
    const { requestGenericRequest } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchRequestReviewData = async () => {
            setLoading(true);
            try {
                if (business_id) {
                    await dispatch(
                        getGenericReviewRequestAysnc({
                            business_id: business_id,
                        })
                    );
                }
            } catch (error) {
                console.error("Error fetching Request Review:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRequestReviewData();
    }, [dispatch, business_id]);

    const handleViewQrCode = () => {
        setViewQrModalOpen(true);
    };

    const handlePrint = () => {
        const printContent = document.getElementById("print-section").innerHTML;
        const WinPrint = window.open('', '', 'width=600,height=800');
        WinPrint.document.write(`
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              text-align: center;
              margin: 0;
              padding: 20px;
            }
            h2 {
              font-size: 24px;
              font-weight: bold;
              text-transform: uppercase;
              margin-bottom: 8px;
            }
            h3 {
              font-size: 18px;
              font-weight: bold;
              margin-top: 0;
              margin-bottom: 20px;
            }
            svg {
              width: 350 !important;
              height: 350 !important;
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
    };

    const linkToCopy = `${window.location.host}/redirect-generic?link=${requestGenericRequest?.review_request_generic?.link}`;
    const restaurantName = requestGenericRequest?.business?.restaurant_name || '';
    const bussinessAddress = requestGenericRequest?.business?.business_address || '';

    return (
        <>
            <Box sx={{ margin: 8 }}>
                <Box display="flex" justifyContent="center">
                    <Box
                        sx={{
                            position: "relative",
                            border: '1px solid rgba(26, 115, 232, 0.4)',
                            width: 256,
                            borderRadius: 6,
                            backgroundColor: "#a9cffb",
                            pb: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: -48,
                                height: 96,
                                width: 96,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                border: "4px solid white",
                                backgroundColor: "#a9cffb",
                            }}
                        >
                            <Typography variant="h5" sx={{ fontSize: "2.50rem", color: "#348BEC" }}>
                                <InsightsIcon />
                            </Typography>
                        </Box>
                        <Box mt={6}>
                            <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: "1.50rem" }}>
                                Grow Smarter
                            </Typography>
                            {/* <Button
                                sx={{
                                    width: "85%",
                                    mt: 2,
                                    backgroundColor: "#318BEC",
                                    borderRadius: "50px",
                                    border: "1px solid rgb(242, 246, 250)",
                                    color: "#fff",
                                    px: 3,
                                    py: 1.3,
                                    "&:hover": {
                                        backgroundColor: "#318BEC",
                                        boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
                                    },
                                }}
                                onClick={handleViewQrCode}
                            >
                                <NavLink style={{ color: "#fff" }}>View QR Code</NavLink>
                            </Button><br /> */}
                            <Button
                                sx={{
                                    width: "85%",
                                    mt: 2,
                                    backgroundColor: "#318BEC",
                                    borderRadius: "50px",
                                    border: "1px solid rgb(242, 246, 250)",
                                    color: "#fff",
                                    px: 3,
                                    py: 1.3,
                                    "&:hover": {
                                        backgroundColor: "#318BEC",
                                        boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
                                    },
                                }}
                            >
                                <NavLink to="/business-intelligence" style={{ color: "#fff" }}>
                                    Business Intelligence
                                </NavLink>
                            </Button><br />
                            <Button
                                sx={{
                                    width: "85%",
                                    mt: 2,
                                    backgroundColor: "#318BEC",
                                    borderRadius: "50px",
                                    border: "1px solid rgb(242, 246, 250)",
                                    color: "#fff",
                                    px: 3,
                                    py: 1.3,
                                    "&:hover": {
                                        backgroundColor: "#318BEC",
                                        boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
                                    },
                                }}
                            >
                                <NavLink to="/marketing-intelligence" style={{ color: "#fff" }}>
                                    Marketing Intelligence
                                </NavLink>
                            </Button><br/>
                            <Button
                                sx={{
                                    width: "85%",
                                    mt: 2,
                                    backgroundColor: "#318BEC",
                                    borderRadius: "50px",
                                    border: "1px solid rgb(242, 246, 250)",
                                    color: "#fff",
                                    px: 3,
                                    py: 1.3,
                                    "&:hover": {
                                        backgroundColor: "#318BEC",
                                        boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
                                    },
                                }}
                            >
                                <NavLink to="/local-intelligence" style={{ color: "#fff" }}>
                                   Local Intelligence
                                </NavLink>
                            </Button><br/>
                            <Button
                                sx={{
                                    width: "85%",
                                    mt: 2,
                                    backgroundColor: "#318BEC",
                                    borderRadius: "50px",
                                    border: "1px solid rgb(242, 246, 250)",
                                    color: "#fff",
                                    px: 3,
                                    py: 1.3,
                                    "&:hover": {
                                        backgroundColor: "#318BEC",
                                        boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
                                    },
                                }}
                            >
                                <NavLink to="/compare-me" style={{ color: "#fff" }}>
                                   Compare Me
                                </NavLink>
                            </Button><br/>
                            <Button
                                sx={{
                                    width: "85%",
                                    mt: 2,
                                    backgroundColor: "#318BEC",
                                    borderRadius: "50px",
                                    border: "1px solid rgb(242, 246, 250)",
                                    color: "#fff",
                                    px: 3,
                                    py: 1.3,
                                    "&:hover": {
                                        backgroundColor: "#318BEC",
                                        boxShadow: "0rem 0.875rem 1.625rem -0.75rem rgba(26, 115, 232, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(26, 115, 232, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(26, 115, 232, 0.2)",
                                    },
                                }}
                            >
                                <NavLink to="/tavlo-moments" style={{ color: "#fff" }}>
                                   Tavlo Moments
                                </NavLink>
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* QR Modal */}
            {/* <Modal open={viewQrModalOpen}>
                <Box sx={style} position="relative" ref={printRef}>
                    <IconButton
                        onClick={() => setViewQrModalOpen(false)}
                        sx={{ position: "absolute", top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontSize: "20px" }} >
                        Scan QR code
                    </Typography>
                    <Typography
                        variant="h6"
                        py={1}
                        sx={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "0px", textTransform: "uppercase" }}
                    >
                        {restaurantName}
                    </Typography>
                    <Typography
                        variant="body1"

                        sx={{ fontSize: "16px", fontWeight: "bold", paddingBottom: "20px" }}
                    >
                        {bussinessAddress}
                    </Typography>
                    <QRCodeSVG value={linkToCopy} width={250} height={250} />
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} gap={2} mt={2}>
                        <Button variant="contained" sx={{ color: "#fff", fontSize: "15px" }} onClick={() => setViewQrModalOpen(false)}>
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            sx={{ display: "flex", alignItems: "center", gap: 1, color: "#fff", fontSize: "15px" }}
                          
                            onClick={() => {
                                navigator.clipboard.writeText(linkToCopy);
                                toast.success("Link Copied Successfully");
                              }}
                        >
                            <ContentCopyIcon sx={{ fontSize: "20px" }} />
                            Copy
                        </Button>
                        <Button
                            variant="contained"
                            sx={{ display: "flex", alignItems: "center", gap: 1, color: "#fff", fontSize: "15px" }}
                            onClick={handlePrint}
                        >
                            <PrintIcon sx={{ fontSize: "20px" }} />
                            Print
                        </Button>
                    </Box>
                </Box>
            </Modal> */}

          
            <div id="print-section" style={{ display: "none" }}>
                <h3 style={{ marginTop: 0, marginBottom: "5px" }}>Scan QR Code</h3>
                <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif" }}>

                    <h2 style={{ marginBottom: "4px", marginTop: 0, textTransform: "uppercase" }}>{restaurantName}</h2>
                    <h3 style={{ marginTop: 0, marginBottom: "15px" }}>{bussinessAddress}</h3>
                    <QRCodeSVG value={linkToCopy} />
                </div>
            </div>
        </>
    );
};

export default BIButton;
